import { render, staticRenderFns } from "./LocationDashboardRecentlyViewed.vue?vue&type=template&id=1115cc3b&scoped=true&"
import script from "./LocationDashboardRecentlyViewed.vue?vue&type=script&lang=ts&"
export * from "./LocationDashboardRecentlyViewed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1115cc3b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
